import { useReactiveVar } from '@apollo/client';
import storage from '../storage/containers';

const { isChatIframedVar } = storage;

const useDetectIframe = () => useReactiveVar(isChatIframedVar);

export default useDetectIframe;
